import React from "react";
import "./presentationSheetContent4.scss";
import "../../../styles/fontSizes.scss";
import imgCVLac from "icons/cvlac.png";
import imgInvestigation from "icons/investigation.png";
import Tag from "componets/atoms/tag/tag";

// data debe contener los datos = {tag,title,email,area, phoneNumber, cvLacLink, investigationLink}

const PresentationSheetContent4 = ({ data }) => {
  return (
    <>
      <div className={`p-sheet-content-4__container font-size--2`}>
        <div className="p-sheet-content-4__first-section">
          {data.tag && (
            <Tag
              textSize={2}
              type={"profesor"}
              className="presentation-sheet-content__text"
              optionalText={data.tag}
            />
          )}

          {data.name && (
            <h1 className="p-sheet-content-4__title">{data.name}</h1>
          )}
          {data.title && (
            <p className="p-sheet-content-4__text">{data.title}</p>
          )}
          <br />
          {data.email && (
            <p className="p-sheet-content-4__text">{data.email}</p>
          )}
          {data.area && <p className="p-sheet-content-4__text">{data.area}</p>}
          {data.phoneNumber && (
            <p className="p-sheet-content-4__text">{data.phoneNumber}</p>
          )}
        </div>
        <div className="p-sheet-content-4__bar" />
        <div className="p-sheet-content-4__second-section">
          {data.cvLacLink && (
            <a target={"_blank"} href={data.cvLacLink}>
              {" "}
              <img src={imgCVLac} alt="Logo de C V Lac" />{" "}
            </a>
          )}
          {data.investigationLink && (
            <a href={data.investigationLink}>
              {" "}
              <img src={imgInvestigation} alt="Logo de investigaciones" />
            </a>
          )}
        </div>
      </div>
    </>
  );
};

export default PresentationSheetContent4;
